import { useEffect, useRef } from "react";
import { useLang } from "../context/LanguageContext";
import SocialIcons from "./SocialIcons";
import { SOCIALS } from "../data/content";

export default function Connect() {
  const { t } = useLang();
  const ref = useRef(null);

  useEffect(() => {
    const items = ref.current?.querySelectorAll(".reveal") || [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 }
    );
    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="connect"
      ref={ref}
      className="relative py-32 lg:py-48 paper-grain watercolor-wash"
      data-testid="connect-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="reveal mb-16 text-center max-w-3xl mx-auto">
          <p className="chapter-num mb-4">{t("connect", "צור קשר")}</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-parchment leading-tight mb-6">
            {t("Find me.", "תמצא אותי.")}{" "}
            <em className="text-four-yellow">{t("Write to me.", "כתוב לי.")}</em>
          </h2>
          <div className="brush-divider mx-auto" />
          <p className="text-lg text-parchment-warm/80 font-light leading-relaxed">
            {t(
              "I publish across seven platforms. Pick the one that matches how you read. The conversation is the same — the room is different.",
              "אני מפרסם בשבע פלטפורמות. בחר את זו שמתאימה לאופן שבו אתה קורא. השיחה אותה — החדר שונה."
            )}
          </p>
        </div>

        <div className="reveal flex justify-center mb-16">
          <SocialIcons size="lg" testIdPrefix="connect-social" />
        </div>

        <div className="reveal grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3 max-w-5xl mx-auto">
          {SOCIALS.map((s) => (
            <a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group text-center p-4 border border-parchment-faint hover:border-four-yellow transition-all duration-500"
              data-testid={`connect-handle-${s.id}`}
            >
              <p className="text-xs tracking-widest uppercase text-parchment-dusk group-hover:text-parchment transition-colors mb-2">
                {s.label}
              </p>
              <p className="font-serif text-sm text-parchment group-hover:text-four-yellow transition-colors break-all">
                {s.handle}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
